<template>
    <div v-if="model">
        <rkm-form ref="RkmForm">
            <rkm-alert
                v-if="form.paciente.isIdoso"
                color="success"
                class="mb-3"
            >
                <rkm-row>
                    <rkm-col>
                        <strong>Acompanhamento do idoso</strong>
                    </rkm-col>
                </rkm-row>

                <rkm-row v-if="!!form.soap.acompanhamentoIdoso.dataUltimaAvaliacaoMultidimensional">
                    <rkm-col>
                        Última avaliação multidimensional: {{form.soap.acompanhamentoIdoso.dataUltimaAvaliacaoMultidimensional}}.
                    </rkm-col>
                </rkm-row>
            </rkm-alert>

            <rkm-tabs>
                <rkm-tab active title="SOAP">
                    <FormSOAP
                        :data="soapData"
                        :fila-id="filaId"
                        :ficha-avaliacao="fichaAvaliacao"
                    />
                </rkm-tab>

                <rkm-tab title="Histórico">
                    <BoxHistorico :data="historicoData" />
                </rkm-tab>

                <rkm-tab title="Histórico - Santa Casa" v-if="form.exibeHistoricoErpsaude">
                    <BoxHistoricoHospitalSantaCasa :data="historicoData" />
                </rkm-tab>

                <rkm-area
                    title="Profissional realizando o atendimento"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col>
                            <strong>Profissional: </strong> {{ autenticacao.usuario.cidadao.nome }}
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong>CBO: </strong> {{ autenticacao.lotacao.ocupacao.codigo }} - {{ autenticacao.lotacao.ocupacao.nome }}
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="autenticacao.usuario.registroTipo && autenticacao.usuario.registroNumero">
                        <rkm-col>
                            <strong>{{ autenticacao.usuario.registroTipoId == enums.tipoRegistro.OUTRO
                                ? autenticacao.usuario.registroTipoOutro
                                : autenticacao.usuario.registroTipo.sigla }}: </strong> {{ autenticacao.usuario.registroNumero }}
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong>Data do atendimento: </strong> {{ additionals.dataAtual }} {{ additionals.horaInicioAtendimento }}
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-tabs>
        </rkm-form>

        <rkm-fab-area>
            <rkm-fab>
                <rkm-fab-item
                    @click="$refs.ModalAlergia.open()"
                    icon="search"
                    label="Alergias e/ou reações adversas"
                />

                <rkm-fab-item
                    @click="$refs.ModalProblemaCondicao.open()"
                    icon="search"
                    label="Problemas e/ou condições"
                />

                <rkm-fab-item
                    @click="$refs.ModalMedicao.open()"
                    icon="search"
                    label="Medições"
                />

                <rkm-fab-item
                    @click="$refs.ModalFerida.open()"
                    icon="search"
                    label="Feridas"
                />

                <rkm-fab-item
                    @click="$refs.ModalMedicamentoUso.open()"
                    icon="search"
                    label="Medicamentos em uso"
                />

                <rkm-fab-item
                    @click="$refs.ModalProblemaCondicaoAutorreferida.open()"
                    icon="search"
                    label="Problemas e/ou condições autorreferidas"
                />

                <rkm-fab-item
                    @click="$refs.ModalResultadoExame.open()"
                    icon="search"
                    label="Resultados de exames"
                />

                <rkm-fab-item
                    v-if="additionals.isCrianca || additionals.isAdolescente"
                    @click="$refs.ModalAcompanhamentoCrianca.open()"
                    icon="search"
                    label="Acompanhamento da criança"
                />

                <rkm-fab-item
                    @click="printCarteiraVacinacao"
                    icon="search"
                    label="Carteira de vacinação"
                />

                <rkm-fab-item
                    @click="$refs.ModalHistoricoPaciente.open()"
                    icon="search"
                    label="Histórico do paciente"
                />

                <rkm-fab-item
                    v-if="!!additionals.faturaProcedimentoRaas && hasProcedimentoRaas"
                    @click="$refs.ModalRaas.open()"
                    icon="search"
                    label="RAAS"
                />

                <rkm-fab-item
                    v-if="!additionals.isDemandaEspontanea && !additionals.oci.recusouContinuidadeOci"
                    @click="$refs.ModalOci.open()"
                    icon="search"
                    label="Protocolos"
                />

                <rkm-fab-item
                    v-if="additionals.criaFichaAtencaoBasicaAtendimentoDomiciliar"
                    @click="$refs.ModalPerfilEpidemiologico.open(model.soap)"
                    icon="search"
                    label="Perfil epidemiológico"
                />

                <rkm-fab-item
                    v-if="criaFormularioIVCF"
                    @click="$refs.ModalFormularioIVCF.open(model.soap.ivcf)"
                    icon="search"
                    label="Formulário IVCF-20"
                />

                <rkm-fab-item
                    v-if="form.paciente.idadeAnos >= 20"
                    @click="$refs.ModalCalculadoraRiscoCardiovascularFramingham.open(model.soap)"
                    icon="search"
                    label="Calculadora de risco cardiovascular (Framingham)"
                />
            </rkm-fab>
        </rkm-fab-area>

        <ModalAlergia
            :data="alergiaData"
            ref="ModalAlergia"
        />

        <ModalProblemaCondicao
            :data="problemaCondicaoData"
            ref="ModalProblemaCondicao"
        />

        <ModalMedicao
            :data="medicaoData"
            ref="ModalMedicao"
        />

        <ModalFerida
            :data="feridaData"
            ref="ModalFerida"
        />

        <ModalMedicamentoUso
            :data="medicamentoUsoData"
            ref="ModalMedicamentoUso"
        />

        <ModalProblemaCondicaoAutorreferida
            :data="problemaCondicaoAutorreferidaData"
            ref="ModalProblemaCondicaoAutorreferida"
        />

        <ModalResultadoExame
            :data="resultadoExameData"
            ref="ModalResultadoExame"
        />

        <ModalAcompanhamentoCrianca
            :data="acompanhamentoCriancaData"
            ref="ModalAcompanhamentoCrianca"
            readonly
        />

        <ModalHistoricoPaciente
            :data="historicoData"
            ref="ModalHistoricoPaciente"
        />

        <ModalRaas
            :data="raasData"
            ref="ModalRaas"
        />

        <ModalImpressao
            @closed="closedModalImpressao"
            ref="ModalImpressao"
        />

        <ModalSignImpressao
            @closed="closedModalSignImpressao"
            @continue="continueModal"
            :sign="true"
            :additionals="additionals"
            ref="ModalSignImpressao"
        />

        <ModalAssinaturaEletronica
            :after-sign="afterSign"
            :ref="modalAssinaturaEletronicaRefName"
            @sign="onSign"
            @skip-sign="onSkipSign"
            v-bind="modalAssinaturaEletronicaProps"
        />

        <ModalOci
            v-if="!additionals.isDemandaEspontanea"
            :data="ociData"
            ref="ModalOci"
        />

        <ModalOciDetalhe
            v-if="additionals.oci.hasOciAtivada"
            :data="ociData"
            ref="ModalOciDetalhe"
        />

        <ModalProcedimentoPrimarioOci
            ref="ModalProcedimentoPrimarioOci"
        />

        <ModalPerfilEpidemiologico
            v-if="additionals.criaFichaAtencaoBasicaAtendimentoDomiciliar"
            :data="{form: form.soap}"
            ref="ModalPerfilEpidemiologico"
        />

        <ModalFormularioIVCF
            v-if="criaFormularioIVCF"
            :data="ivcfData"
            ref="ModalFormularioIVCF"
        />

        <ModalCalculadoraRiscoCardiovascularFramingham
            v-if="form.paciente.idadeAnos >= 20"
            :data="{form, model}"
            ref="ModalCalculadoraRiscoCardiovascularFramingham"
        />
    </div>
</template>

<script>
// Components.
import BoxHistorico from './components/historico/Index'
import BoxHistoricoHospitalSantaCasa from '@/components/ambulatorio/atendimento/components/historico-hospital-santa-casa/Index'
import FormSOAP from './components/soap/Form'
import ModalAcompanhamentoCrianca from './components/acompanhamento-crianca/Modal'
import ModalAlergia from './components/alergia/Modal'
import ModalCalculadoraRiscoCardiovascularFramingham from './components/calculadora-risco-cardiovascular-framingham/Modal'
import ModalFerida from './components/ferida/Modal'
import ModalFormularioIVCF from './components/formulario-ivcf/Modal'
import ModalHistoricoPaciente from '@/components/ambulatorio/atendimento/components/historico/Modal'
import ModalImpressao from '@/components/ambulatorio/components/impressao/Modal'
import ModalMedicamentoUso from './components/medicamento-uso/Modal'
import ModalMedicao from './components/medicao/Modal'
import ModalOci from './components/oci/Modal'
import ModalOciDetalhe from './components/oci/components/detalhe/Modal'
import ModalPerfilEpidemiologico from './components/perfil-epidemiologico/Modal'
import ModalProblemaCondicao from './components/problema-condicao/Modal'
import ModalProblemaCondicaoAutorreferida from './components/problema-condicao-autorreferida/Modal'
import ModalProcedimentoPrimarioOci from './components/procedimento-primario-oci/Modal'
import ModalRaas from './components/raas/Modal'
import ModalResultadoExame from './components/resultado-exame/Modal'
import ModalSignImpressao from '@/components/ambulatorio/components/impressao/Modal'

// Enums.
import procedimento from '@/enums/sigtap/procedimento'
import tipoRegistro from '@/enums/cadastro/usuario/tipoRegistro'
import etapaClinica from '@/enums/cadastro/oci/etapaClinica'

// Mixins.
import {ambulatorioAtendimentoExame, ambulatorioAtendimentoPreNatal, ambulatorioAssinaturaEletronica, error, file, formats, object, repository, stringCase, unmask} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        BoxHistorico,
        BoxHistoricoHospitalSantaCasa,
        FormSOAP,
        ModalAcompanhamentoCrianca,
        ModalAlergia,
        ModalCalculadoraRiscoCardiovascularFramingham,
        ModalFerida,
        ModalFormularioIVCF,
        ModalHistoricoPaciente,
        ModalImpressao,
        ModalMedicamentoUso,
        ModalMedicao,
        ModalOci,
        ModalOciDetalhe,
        ModalPerfilEpidemiologico,
        ModalProblemaCondicao,
        ModalProblemaCondicaoAutorreferida,
        ModalProcedimentoPrimarioOci,
        ModalRaas,
        ModalResultadoExame,
        ModalSignImpressao,
    },
    computed: {
        ...mapGetters({
            autenticacao: 'getAutenticacao',
            centroCusto: 'getCentroCusto',
            lotacao: 'getLotacao',
        }),
        hasGravidezNormal() {
            return !!this.getProblemaCondicaoGravidezNormal()
        },
        hasGravidezAltoRisco() {
            return this.getProblemasCondicoesGravidezAltoRisco().length > 0
        },
        hasDesfechoGravidez() {
            return this.getProblemasCondicoesDesfechoGravidez().length > 0
        },
        hasGravidezNormalAdicionadaAnteriormente() {
            return !!this.getProblemaCondicaoPacienteGravidezNormal()
        },
        hasDesfechoGravidezAdicionadoAnteriormente() {
            return this.getProblemaCondicaoPacienteDesfechoGravidez().length > 0
        },
        isAtendimentoPreNatal() {
            return this.hasGravidezNormal || this.hasGravidezNormalAdicionadaAnteriormente
        },
        isPrimeiroAtendimentoPreNatal() {
            return this.hasGravidezNormal && !this.hasGravidezNormalAdicionadaAnteriormente
        },
        additionalsData() {
            return {
                ...this.additionals,
                paciente: this.form.paciente,
                hasGravidezNormal: this.hasGravidezNormal,
                hasGravidezAltoRisco: this.hasGravidezAltoRisco,
                hasDesfechoGravidez: this.hasDesfechoGravidez,
                hasGravidezNormalAdicionadaAnteriormente: this.hasGravidezNormalAdicionadaAnteriormente,
                hasDesfechoGravidezAdicionadoAnteriormente: this.hasDesfechoGravidezAdicionadoAnteriormente,
                problemasCondicoesGravidez: this.getProblemasCondicoesGravidez(),
                problemaCondicaoGravidezNormal: this.getProblemaCondicaoGravidezNormal(),
                problemasCondicoesGravidezAltoRisco: this.getProblemasCondicoesGravidezAltoRisco(),
                problemaCondicaoPacienteGravidezNormal: this.getProblemaCondicaoPacienteGravidezNormal(),
                isAtendimentoPreNatal: this.isAtendimentoPreNatal,
                isPrimeiroAtendimentoPreNatal: this.isPrimeiroAtendimentoPreNatal,
                isRetroativo: this.isRetroativo,
            }
        },
        soapData() {
            return {
                additionals: this.additionalsData,
                form: {...this.form.soap, paciente: this.form.paciente},
                historicoSoap: this.form.historicoSoap,
                model: this.model.soap,
            }
        },
        historicoData() {
            return {
                form: this.form,
            }
        },
        alergiaData() {
            const form = this.form.soap.avaliacao.alergia

            return {
                form: {
                    alergiaCriticidades: form.criticidades,
                    alergiaTipos: form.tipos,
                },
                model: {alergias: this.model.soap.avaliacao.alergiasReacoesAdversas},
            }
        },
        problemaCondicaoData() {
            return {
                additionals: this.additionalsData,
                form: this.form.soap,
                model: this.model.soap,
            }
        },
        medicaoData() {
            return {
                additionals: this.additionalsData,
                form: this.form.soap.medicoes,
                model: this.model.soap.medicoes,
            }
        },
        feridaData() {
            return {
                additionals: this.additionalsData,
                form: this.form.soap.feridas,
                model: this.model.soap.feridas,
                soap: this.model.soap,
            }
        },
        medicamentoUsoData() {
            return {
                additionals: this.additionalsData,
                form: this.form.soap,
                model: this.model.soap,
            }
        },
        problemaCondicaoAutorreferidaData() {
            return {
                form: this.form.soap,
                model: this.model.soap,
            }
        },
        raasData() {
            return {
                form: this.form.soap,
                model: this.model.soap,
                hasProcedimentoRaas: this.hasProcedimentoRaas,
                hasProcedimentoRaasQuePrecisaDeClassificacao: this.hasProcedimentoRaasQuePrecisaDeClassificacao,
                hasProcedimentoRaasQuePrecisaDeAutorizacao: this.hasProcedimentoRaasQuePrecisaDeAutorizacao,
            }
        },
        resultadoExameData() {
            return {
                additionals: this.additionalsData,
                form: this.form.soap.objetivo,
                model: this.model.soap.objetivo,
            }
        },
        acompanhamentoCriancaData() {
            return {
                additionals: this.additionalsData,
                form: this.form.soap.objetivo,
                model: this.model.soap.objetivo,
            }
        },
        ociData() {
            return {
                additionals: this.additionalsData,
                model: this.model.soap.oci,
            }
        },
        hasProcedimentoRaas() {

            return this.form.soap.raas.hasProcedimentoRaas || this.procedimentosRaasLancados.length > 0
        },
        hasProcedimentoRaasQuePrecisaDeClassificacao() {

            return this.form.soap.raas.hasProcedimentoRaasQuePrecisaDeClassificacao
                || this.procedimentosRaasLancados.some(codigo => codigo
                    === this.enums.procedimento.ACOMPANHAMENTO_DE_PACIENTE_EM_SAUDE_MENTAL)
        },
        hasProcedimentoRaasQuePrecisaDeAutorizacao() {

            const procedimentos = [
                this.enums.procedimento.ACOMPANHAMENTO_DE_PACIENTE_EM_SAUDE_MENTAL,
                this.enums.procedimento.ACOMPANHAMENTO_DE_PESSOAS_COM_NECESSIDADES_DECORRENTES_DO_USO_DE_ALCOOL_CRACK_E_OUTRAS_DROGAS,
                this.enums.procedimento.ACOMPANHAMENTO_DE_PESSOAS_ADULTAS_COM_SOFRIMENTO_OU_TRANSTORNOS_MENTAIS_DECORRENTES_DO_USO_DE_CRACK_ALCOOL_E_OUTRAS_DROGAS,
                this.enums.procedimento.ACOMPANHAMENTO_DA_POPULACAO_INFANTO_JUVENIL_COM_SOFRIMENTO_OU_TRANSTORNOS_MENTAIS_DECORRENTES_DO_USO_DE_CRACK_ALCOOL_E_OUTRAS_DROGAS,
            ]

            return this.form.soap.raas.hasProcedimentoRaasQuePrecisaDeAutorizacao
                || this.procedimentosRaasLancados.some(codigo => procedimentos.includes(codigo))
        },
        procedimentosRaasLancados() {

            return this.model.soap.plano.procedimentosClinicos.filter(p => !!p.procedimento.hasInstrumentoRegistroRaas)
                .concat(this.model.soap.finalizacao.procedimentosAdministrativos.filter(p => !!p.procedimento.hasInstrumentoRegistroRaas))
                .map(p => p.procedimento.codigo)
        },
        isRetroativo() {

            return this.filaId === 0
        },
        hasProcedimentoLancado() {

            return this.model.soap.plano.procedimentosClinicos.length > 0
                || this.model.soap.finalizacao.procedimentosAdministrativos.length > 0
                || this.model.soap.plano.saudeBucal.odontograma.arcadas.superior.procedimentos.length > 0
                || this.model.soap.plano.saudeBucal.odontograma.arcadas.superior.dentes.permanentes.some(d => d.procedimentos.length > 0)
                || this.model.soap.plano.saudeBucal.odontograma.arcadas.superior.dentes.deciduos.some(d => d.procedimentos.length > 0)
                || this.model.soap.plano.saudeBucal.odontograma.arcadas.inferior.procedimentos.length > 0
                || this.model.soap.plano.saudeBucal.odontograma.arcadas.inferior.dentes.permanentes.some(d => d.procedimentos.length > 0)
                || this.model.soap.plano.saudeBucal.odontograma.arcadas.inferior.dentes.deciduos.some(d => d.procedimentos.length > 0)
                || this.model.soap.plano.saudeBucal.odontograma.dentesSupranumerarios.some(d => d.procedimentos.length > 0)
                || this.hasDadosParaProcedimentoClinicoAutomatico

        },
        hasDadosParaProcedimentoClinicoAutomatico() {

            return this.model.soap.objetivo.antropometria.peso
                || this.model.soap.objetivo.antropometria.altura
                || this.model.soap.objetivo.sinalVital.pressaoArterial
                || this.model.soap.objetivo.sinalVital.temperatura
                || this.model.soap.objetivo.glicemiaCapilar.valor
                || this.model.soap.objetivo.isAtendimentoPuericultura
        },
        ivcfData() {

            return {
                form: this.form,
            }
        },
        criaFormularioIVCF() {

            return this.form.paciente.idadeAnos >= 60 && (
                this.additionals.criaFichaAtencaoBasicaAtendimentoIndividual
                    || this.additionals.criaFichaAtencaoBasicaAtendimentoDomiciliar
                    || this.additionals.criaFichaAtencaoBasicaAtendimentoOdontologico
            )
        },
    },
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            impressaoImunizacao: this.getConectaSusRepository('impressao.imunizacao'),
        }
    },
    data: () => ({
        additionals: null,
        enums: {procedimento, tipoRegistro, etapaClinica},
        form: null,
        model: null,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.create()
        },
        create() {
            this.setLoading()

            this.repositories.atendimento.create(this.filaId, this.agendamentoId)
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    if (this.additionals.oci.hasOciAtivada) {

                        this.showConfirmation(
                            `Paciente possui protocolo ativo de
                            ${this.model.soap.oci.oci.linhaCuidado}/${this.model.soap.oci.oci.nome}.
                            Deseja prosseguir vinculando este atendimento ao protocolo?`,
                            async () => {

                                this.addProblemasCondicoesAnterioresOci()

                                this.$refs.ModalOciDetalhe.open()
                            },
                            async () => {

                                this.$nextTick().then(() => {

                                    this.showConfirmation(
                                        `Este atendimento não fará parte do protocolo ${this.model.soap.oci.oci.nome}. Deseja prosseguir?`,
                                        async () => {

                                            this.additionals.oci.recusouContinuidadeOci = true
                                        },
                                        async () => {

                                            this.addProblemasCondicoesAnterioresOci()

                                            this.$refs.ModalOciDetalhe.open()
                                        }
                                    )
                                })
                            }
                        )
                    }

                    this.$emit('loaded', {additionals: this.additionals, form: this.form, model: this.model})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },

        addProblemasCondicoesAnterioresOci() {

            this.additionals.oci.problemasCondicoesLancadosEtapaEntrada.forEach(problemaCondicao => {

                this.model.soap.avaliacao.problemasCondicoes.push(problemaCondicao)
            })
        },
        store(rascunho = false) {
            const antecedenteModel = this.model.soap.antecedentes
            const subjetivoModel = this.model.soap.subjetivo
            const objetivoModel = this.model.soap.objetivo
            const avaliacaoModel = this.model.soap.avaliacao
            const planoModel = this.model.soap.plano
            const finalizacaoModel = this.model.soap.finalizacao
            const ociModel = this.model.soap.oci
            const alteracoesFenotipicas = []
            const fatoresRisco = []
            const marcosDesenvolvimento = []
            const questionarioMChatR = []
            let finalizado = null

            this.setLoading()

            objetivoModel.puericultura.alteracoesFenotipicas.forEach(alteracaoFenotipica => {
                alteracoesFenotipicas.push({
                    id: alteracaoFenotipica.id,
                    isPresente: alteracaoFenotipica.isPresente,
                })
            })

            objetivoModel.puericultura.fatoresRisco.forEach(fatorRisco => {
                fatoresRisco.push({
                    id: fatorRisco.id,
                    isPresente: fatorRisco.isPresente,
                })
            })

            objetivoModel.puericultura.marcosDesenvolvimento.forEach(marcoDesenvolvimento => {
                marcoDesenvolvimento.perguntas.forEach(pergunta => {
                    marcosDesenvolvimento.push({
                        id: pergunta.id,
                        isPresente: pergunta.isPresente,
                        alcancadoComAnos: pergunta.alcancadoComAnos,
                        alcancadoComMeses: pergunta.alcancadoComMeses,
                    })
                })
            })

            objetivoModel.puericultura.questionarioMChatR.forEach(questionario => {
                questionarioMChatR.push({
                    id: questionario.id,
                    resposta: questionario.resposta,
                })
            })

            if (rascunho === true || finalizacaoModel.desfecho.finalizado === 'encaminhar') {
                finalizado = false
            } else {
                finalizado = finalizacaoModel.desfecho.finalizado
            }

            let request = {
                isRascunho: rascunho,
                filaId: this.isRetroativo ? null : this.filaId,
                agendamentoId: this.agendamentoId ?? null,
                ultimaEtapaOciRealizadaMesmoAtendimento: this.additionals.oci.ultimaEtapaRealizadaMesmoAtendimento,
                ociId: ociModel.oci && !this.additionals.oci.recusouContinuidadeOci ? ociModel.oci.id : null,
                acompanhamentoOciId: !this.additionals.oci.recusouContinuidadeOci ? this.additionals.oci.acompanhamentoOciId : null,
                ociProcedimentosRealizadosPreviamente: ociModel.oci && !this.additionals.oci.recusouContinuidadeOci
                    ? ociModel.oci.procedimentosRealizadosPreviamente.map(procedimento => ({
                        id: procedimento.id,
                        dataExecutada: procedimento.dataExecutada,
                        unidadeExecutoraId: procedimento.unidadeExecutoraId,
                        ocupacaoExecutoraId: procedimento.ocupacaoExecutoraId,
                        usuarioExecutor: procedimento.usuarioExecutor
                    }))
                    : [],
                paciente: {
                    telefonePrincipal: {
                        id: this.form.paciente.telefoneId,
                        numero: this.form.paciente.telefoneNumero ? this.unMaskPhone(this.form.paciente.telefoneNumero) : null,
                        autorizaSms: this.form.paciente.telefoneAutorizaSms,
                        atualizado: this.form.paciente.telefoneAtualizado,
                    },
                },
                antecedente: {
                    descricao: antecedenteModel.descricao,
                    gestasPrevias: antecedenteModel.informacoesObstetricas.gestasPrevias,
                    abortos: antecedenteModel.informacoesObstetricas.abortos,
                    desfechoGestacaoAconteceuMenosUmAno: antecedenteModel.informacoesObstetricas.desfechoGestacaoAconteceuMenosUmAno,
                    partosRealizados: antecedenteModel.informacoesObstetricas.partosRealizados,
                    partosVaginais: antecedenteModel.informacoesObstetricas.partosVaginais,
                    partosCesareas: antecedenteModel.informacoesObstetricas.partosCesareas,
                    partosDomiciliares: antecedenteModel.informacoesObstetricas.partosDomiciliares,
                    nascidosVivos: antecedenteModel.informacoesObstetricas.nascidosVivos,
                    nascidosMortos: antecedenteModel.informacoesObstetricas.nascidosMortos,
                    recemNascidosComMenos2500Gramas: antecedenteModel.informacoesObstetricas.recemNascidosComMenos2500Gramas,
                    recemNascidosComMais4500Gramas: antecedenteModel.informacoesObstetricas.recemNascidosComMais4500Gramas,
                    nascidosVivosVivem: antecedenteModel.informacoesObstetricas.nascidosVivosVivem,
                    nascidosVivosMortosPrimeiraSemana: antecedenteModel.informacoesObstetricas.nascidosVivosMortosPrimeiraSemana,
                    nascidosVivosMortosDepoisPrimeiraSemana: antecedenteModel.informacoesObstetricas.nascidosVivosMortosDepoisPrimeiraSemana,
                    problemasCondicoes: antecedenteModel.problemasCondicoes.map(problemaCondicao => {
                        return {
                            ciapId: problemaCondicao.ciap ? problemaCondicao.ciap.id : null,
                            cidId: problemaCondicao.cid ? problemaCondicao.cid.id : null,
                            situacaoId: problemaCondicao.situacaoId,
                            inicio: problemaCondicao.inicio ? problemaCondicao.inicio.data : null,
                            fim: problemaCondicao.fim ? problemaCondicao.fim.data : null,
                            observacao: problemaCondicao.observacao,
                        }
                    }),
                    cirurgiasInternacoes: antecedenteModel.cirurgiasInternacoes.map(cirurgiaInternacao => {
                        return {
                            descricao: cirurgiaInternacao.descricao,
                            realizadaEm: cirurgiaInternacao.realizadaEm ? cirurgiaInternacao.realizadaEm.data : null,
                            observacao: cirurgiaInternacao.observacao,
                        }
                    }),
                    problemasFamiliares: antecedenteModel.problemasFamiliares.map(problemaFamiliar => {
                        return {
                            ciapId: problemaFamiliar.ciap.id,
                            observacao: problemaFamiliar.observacao,
                        }
                    }),
                    descricaoFamiliar: antecedenteModel.descricaoFamiliar,
                },
                subjetivo: {
                    descricao: subjetivoModel.descricao,
                    motivos: subjetivoModel.motivos.map(motivo => {
                        return {
                            ciapId: motivo.ciap ? motivo.ciap.id : null,
                            cidId: motivo.cid ? motivo.cid.id : null,
                            observacao: motivo.observacao,
                        }
                    }),
                },
                objetivo: {
                    descricao: objetivoModel.descricao,
                    dum: objetivoModel.dum ? this.others.moment(objetivoModel.dum).format('DD/MM/YYYY') : null,
                    vacinacaoEmDia: objetivoModel.vacinacaoEmDia,
                    pacienteComNecessidadeEspecial: objetivoModel.pacienteComNecessidadeEspecial,
                    antropometria: {
                        peso: objetivoModel.antropometria.peso,
                        altura: objetivoModel.antropometria.altura,
                        perimetroCefalico: objetivoModel.antropometria.perimetroCefalico,
                        circunferenciaAbdominal: objetivoModel.antropometria.circunferenciaAbdominal,
                        perimetroPanturrilha: objetivoModel.antropometria.perimetroPanturrilha,
                        comprimentoPeDireito: objetivoModel.antropometria.comprimentoPeDireito,
                        larguraPeDireito: objetivoModel.antropometria.larguraPeDireito,
                        circunferenciaPeDireito: objetivoModel.antropometria.circunferenciaPeDireito,
                        comprimentoPeEsquerdo: objetivoModel.antropometria.comprimentoPeEsquerdo,
                        larguraPeEsquerdo: objetivoModel.antropometria.larguraPeEsquerdo,
                        circunferenciaPeEsquerdo: objetivoModel.antropometria.circunferenciaPeEsquerdo,
                    },
                    sinalVital: {
                        pressaoArterial: objetivoModel.sinalVital.pressaoArterial,
                        frequenciaRespiratoria: objetivoModel.sinalVital.frequenciaRespiratoria,
                        frequenciaCardiaca: objetivoModel.sinalVital.frequenciaCardiaca,
                        temperatura: objetivoModel.sinalVital.temperatura,
                        saturacaoO2: objetivoModel.sinalVital.saturacaoO2,
                    },
                    glicemiaCapilar: {
                        valor: objetivoModel.glicemiaCapilar.valor,
                        momentoColetaId: objetivoModel.glicemiaCapilar.momentoColetaId,
                    },
                    marcadorConsumoAlimentar: objetivoModel.marcadorConsumoAlimentar,
                    resultadosExames: objetivoModel.resultadosExames.map(resultadoExame => {
                        return {
                            exameId: resultadoExame.exame.id,
                            idadeGestacionalSemanasEco: resultadoExame.idadeGestacionalSemanasEco,
                            idadeGestacionalDiasEco: resultadoExame.idadeGestacionalDiasEco,
                            dppEco: resultadoExame.dppEco ? this.others.moment(resultadoExame.dppEco).format('DD/MM/YYYY') : null,
                            solicitadoEm: resultadoExame.solicitadoEm,
                            realizadoEm: resultadoExame.realizadoEm,
                            resultadoEm: resultadoExame.resultadoEm,
                            percentual: resultadoExame.percentual,
                            resultadoTipoId: resultadoExame.resultadoTipoId,
                            resultado: resultadoExame.resultado,
                        }
                    }),
                    exameAvaliado: objetivoModel.exameAvaliado.map(exameAvaliado => {
                        return {
                            id: exameAvaliado.id,
                            solicitadoEm: exameAvaliado.solicitadoEm ? this.others.moment(exameAvaliado.solicitadoEm).format('DD/MM/YYYY') : null,
                            realizadoEm: exameAvaliado.realizadoEm ? this.others.moment(exameAvaliado.realizadoEm).format('DD/MM/YYYY') : null,
                            resultadoEm: exameAvaliado.resultadoEm ? this.others.moment(exameAvaliado.resultadoEm).format('DD/MM/YYYY') : null,
                            resultado: exameAvaliado.resultado,
                        }
                    }),
                    triagemNeonatal: objetivoModel.triagemNeonatal.map(triagemNeonatal => {
                        return {
                            id: triagemNeonatal.id,
                            solicitadoEm: triagemNeonatal.solicitadoEm ? this.others.moment(triagemNeonatal.solicitadoEm).format('DD/MM/YYYY') : null,
                            realizadoEm: triagemNeonatal.realizadoEm ? this.others.moment(triagemNeonatal.realizadoEm).format('DD/MM/YYYY') : null,
                            resultadoEm: triagemNeonatal.resultadoEm ? this.others.moment(triagemNeonatal.resultadoEm).format('DD/MM/YYYY') : null,
                            resultado: triagemNeonatal.resultado,
                        }
                    }),
                    preNatal: {
                        gravidezTipoId: objetivoModel.preNatal.gravidezTipoId,
                        alturaUterina: objetivoModel.preNatal.alturaUterina,
                        edemaId: objetivoModel.preNatal.edemaId,
                        movimentacaoFetal: objetivoModel.preNatal.movimentacaoFetal,
                        gravidezPlanejada: objetivoModel.preNatal.gravidezPlanejada,
                        batimentoCardiacoFetal: objetivoModel.preNatal.batimentoCardiacoFetal,
                    },
                    isAtendimentoPuericultura: objetivoModel.isAtendimentoPuericultura,
                    puericultura: this.additionals.isPrimeiroAtendimentoPuericultura
                        ? Object.assign(this.clone(objetivoModel.puericultura), {
                            alteracoesFenotipicas,
                            fatoresRisco,
                            marcosDesenvolvimento,
                            questionarioMChatR,
                        })
                        : {
                            ...antecedenteModel.puericultura,
                            aleitamentoTipoId: objetivoModel.puericultura.aleitamentoTipoId,
                            alteracoesFenotipicas,
                            fatoresRisco,
                            marcosDesenvolvimento,
                            questionarioMChatR,
                        },
                },
                avaliacao: {
                    descricao: avaliacaoModel.descricao,
                    condicoesAvaliadas: avaliacaoModel.condicoesAvaliadas,
                    condicoesEmad: avaliacaoModel.condicoesEmad,
                    doencasTransmissiveis: avaliacaoModel.doencasTransmissiveis,
                    rastreamentos: avaliacaoModel.rastreamentos,
                    problemasCondicoes: avaliacaoModel.problemasCondicoes.map(problemaCondicao => {
                        return {
                            id: problemaCondicao.id,
                            automatico: problemaCondicao.automatico,
                            ciapId: problemaCondicao.ciap ? problemaCondicao.ciap.id : null,
                            cidId: problemaCondicao.cid ? problemaCondicao.cid.id : null,
                            situacaoId: problemaCondicao.situacaoId,
                            inicio: problemaCondicao.inicio ? problemaCondicao.inicio.data : null,
                            fim: problemaCondicao.fim ? problemaCondicao.fim.data : null,
                            observacao: problemaCondicao.observacao,
                        }
                    }),
                    preNatal: {
                        gravidezTipoId: avaliacaoModel.preNatal.gravidezTipoId,
                        alturaUterina: avaliacaoModel.preNatal.alturaUterina,
                        edemaId: avaliacaoModel.preNatal.edemaId,
                        movimentacaoFetal: avaliacaoModel.preNatal.movimentacaoFetal,
                        gravidezPlanejada: avaliacaoModel.preNatal.gravidezPlanejada,
                        batimentoCardiacoFetal: avaliacaoModel.preNatal.batimentoCardiacoFetal,
                        desfechoEm: avaliacaoModel.preNatal.desfechoEm ? this.others.moment(avaliacaoModel.preNatal.desfechoEm).format('DD/MM/YYYY') : null,
                    },
                    saudeBucal: {
                        necessidadeProteseInferiorSuperior: avaliacaoModel.saudeBucal.necessidadeProteseInferiorSuperior,
                        vigilancias: avaliacaoModel.saudeBucal.vigilancias,
                    },
                    alergiasReacoesAdversas: avaliacaoModel.alergiasReacoesAdversas.map(alergiaReacaoAdversa => {
                        return {
                            alergiaId: alergiaReacaoAdversa.alergia.id,
                            criticidadeId: alergiaReacaoAdversa.alergia.criticidade.id,
                            reacoesObservacoes: alergiaReacaoAdversa.alergia.reacoesObservacoes,
                        }
                    }),
                },
                plano: {
                    descricao: planoModel.descricao,
                    orientacaoIndividualEmSaude: planoModel.orientacaoIndividualEmSaude,
                    intervencoes: planoModel.intervencoes.map(intervencao => {
                        return {
                            ciapId: intervencao.ciap.id,
                            observacao: intervencao.observacao,
                        }
                    }),
                    procedimentosClinicos: planoModel.procedimentosClinicos.map(procedimentoClinico => {
                        return {
                            procedimentoId: procedimentoClinico.procedimento.id,
                            cidId: procedimentoClinico.cid ? procedimentoClinico.cid.id : null,
                            automatico: procedimentoClinico.automatico,
                            quantidade: procedimentoClinico.quantidade,
                            observacao: procedimentoClinico.observacao,
                            materiais: procedimentoClinico.procedimento.materiais ? procedimentoClinico.procedimento.materiais.map(m => ({
                                materialId: m.id,
                                materialQuantidade: m.quantidade,
                                materialEscolheuEntradaItemManualmente: m.materialEscolheuEntradaItemManualmente,
                                materialEntradaItens: m.materialEntradaItens
                                    ? m.materialEntradaItens.filter(i => i.quantidadeSaida > 0)
                                    : [],
                                }))
                            : [],
                        }
                    }),
                    procedimentosEmad: planoModel.procedimentosEmad.map(procedimento => {
                        return {
                            id: procedimento.id,
                            codigo: procedimento.codigo
                        }
                    }),
                    saudeBucal: {
                        odontograma: {
                            possuiAparelho: planoModel.saudeBucal.odontograma.possuiAparelho,
                            possuiContencao: planoModel.saudeBucal.odontograma.possuiContencao,
                            arcadas: {
                                superior: {
                                    possuiProteseTotal: planoModel.saudeBucal.odontograma.protesesTotais.includes('superior'),
                                    observacao: planoModel.saudeBucal.odontograma.arcadas.superior.observacao,
                                    procedimentos: planoModel.saudeBucal.odontograma.arcadas.superior.procedimentos.map(procedimento => {
                                        return {
                                            procedimentoId: procedimento.procedimento.id,
                                            cidId: procedimento.cid ? procedimento.cid.id : null,
                                            quantidade: procedimento.quantidade,
                                        }
                                    }),
                                    dentes: planoModel.saudeBucal.odontograma.arcadas.superior.dentes.permanentes
                                        .concat(planoModel.saudeBucal.odontograma.arcadas.superior.dentes.deciduos)
                                        .map(dente => {
                                            return {
                                                denteId: dente.id,
                                                fragmentos: {
                                                    esquerda: {
                                                        isTratado: dente.fragmentos.esquerda.isTratado,
                                                    },
                                                    cima: {
                                                        isTratado: dente.fragmentos.cima.isTratado,
                                                    },
                                                    direita: {
                                                        isTratado: dente.fragmentos.direita.isTratado,
                                                    },
                                                    baixo: {
                                                        isTratado: dente.fragmentos.baixo.isTratado,
                                                    },
                                                    centro: {
                                                        isTratado: dente.fragmentos.centro.isTratado,
                                                    },
                                                },
                                                problemasCondicoes: dente.problemasCondicoes,
                                                procedimentos: dente.procedimentos.map(procedimento => {
                                                    return {
                                                        procedimentoId: procedimento.procedimento.id,
                                                        cidId: procedimento.cid ? procedimento.cid.id : null,
                                                        quantidade: procedimento.quantidade,
                                                    }
                                                }),
                                                observacao: dente.observacao
                                            }
                                        }),
                                },
                                inferior: {
                                    possuiProteseTotal: planoModel.saudeBucal.odontograma.protesesTotais.includes('inferior'),
                                    observacao: planoModel.saudeBucal.odontograma.arcadas.inferior.observacao,
                                    procedimentos: planoModel.saudeBucal.odontograma.arcadas.inferior.procedimentos.map(procedimento => {
                                        return {
                                            procedimentoId: procedimento.procedimento.id,
                                            cidId: procedimento.cid ? procedimento.cid.id : null,
                                            quantidade: procedimento.quantidade,
                                        }
                                    }),
                                    dentes: planoModel.saudeBucal.odontograma.arcadas.inferior.dentes.permanentes
                                        .concat(planoModel.saudeBucal.odontograma.arcadas.inferior.dentes.deciduos)
                                        .map(dente => {
                                            return {
                                                denteId: dente.id,
                                                fragmentos: {
                                                    esquerda: {
                                                        isTratado: dente.fragmentos.esquerda.isTratado,
                                                    },
                                                    cima: {
                                                        isTratado: dente.fragmentos.cima.isTratado,
                                                    },
                                                    direita: {
                                                        isTratado: dente.fragmentos.direita.isTratado,
                                                    },
                                                    baixo: {
                                                        isTratado: dente.fragmentos.baixo.isTratado,
                                                    },
                                                    centro: {
                                                        isTratado: dente.fragmentos.centro.isTratado,
                                                    },
                                                },
                                                problemasCondicoes: dente.problemasCondicoes,
                                                procedimentos: dente.procedimentos.map(procedimento => {
                                                    return {
                                                        procedimentoId: procedimento.procedimento.id,
                                                        cidId: procedimento.cid ? procedimento.cid.id : null,
                                                        quantidade: procedimento.quantidade,
                                                    }
                                                }),
                                                observacao: dente.observacao
                                            }
                                        }),
                                },
                            },
                            dentesSupranumerarios: planoModel.saudeBucal.odontograma.dentesSupranumerarios.map(denteSupranumerario => {
                                return {
                                    local: denteSupranumerario.local,
                                    observacao: denteSupranumerario.observacao,
                                    procedimentos: denteSupranumerario.procedimentos.map(procedimento => {
                                        return {
                                            procedimentoId: procedimento.procedimento.id,
                                            cidId: procedimento.cid ? procedimento.cid.id : null,
                                            quantidade: procedimento.quantidade,
                                        }
                                    }),
                                }
                            })
                        },
                    },
                    prescricoesMedicamentos: (planoModel.prescricaoMedicamentos.length === 0 ? [] : [{medicamentos: planoModel.prescricaoMedicamentos}]).concat(planoModel.prescricoesMedicamentosClonados).map(prescricaoMedicamento => {
                        return {
                            medicamentos: prescricaoMedicamento.medicamentos.map(medicamento => {
                                if (medicamento.isManual) {
                                    return {
                                        isManual: medicamento.isManual,
                                        receitaTipoId: medicamento.receitaTipoId,
                                        isImprimirSeparado: medicamento.isImprimirSeparado,
                                        descricao: medicamento.descricao,
                                        justificativa: medicamento.justificativa,
                                        recomendacoes: medicamento.recomendacoes,
                                        prescricaoMedicamentoItemAnteriorId: medicamento.prescricaoMedicamentoItemAnteriorId ?? null
                                    }
                                } else {
                                    return {
                                        isManual: medicamento.isManual,
                                        receitaTipoId: medicamento.receitaTipoId,
                                        materialId: medicamento.material ? medicamento.material.id : null,
                                        dose: medicamento.dose,
                                        unidadeMedidaId: medicamento.unidadeMedidaId,
                                        isDoseUnica: medicamento.isDoseUnica,
                                        frequenciaDose: medicamento.frequenciaDose,
                                        turnoId: medicamento.turnoId,
                                        intervalo: medicamento.intervalo,
                                        intervaloMedidaTempoId: medicamento.intervaloMedidaTempoId,
                                        frequenciaVezes: medicamento.frequenciaVezes,
                                        isUsoContinuo: medicamento.isUsoContinuo,
                                        isImprimirSeparado: medicamento.isImprimirSeparado,
                                        isRemoverImpressao: medicamento.isRemoverImpressao,
                                        inicio: medicamento.inicio ? medicamento.inicio : null,
                                        duracao: medicamento.duracao,
                                        duracaoMedidaTempoId: medicamento.duracaoMedidaTempoId === 'indeterminado' ? null : medicamento.duracaoMedidaTempoId,
                                        recomendacoes: medicamento.recomendacoes,
                                        prescricaoMedicamentoItemAnteriorId: medicamento.prescricaoMedicamentoItemAnteriorId ?? null
                                    }
                                }
                            })
                        }
                    }),
                    exameSolicitado: {
                            exames: planoModel.exameSolicitado.map(exame => {
                                return {exameId: exame.id}
                            }),
                            cidId: planoModel.exameSolicitadoCid ? planoModel.exameSolicitadoCid.id : null,
                            ciapId: planoModel.exameSolicitadoCiap ? planoModel.exameSolicitadoCiap.id : null,
                            justificativa: planoModel.exameSolicitadoJustificativa ?? null,
                            observacao: planoModel.exameSolicitadoObservacao ?? null,
                    },
                    triagemNeonatal: {
                        exames: planoModel.triagemNeonatal.map(exame => {
                            return {exameId: exame.id}
                        }),
                        cidId: planoModel.triagemNeonatalCid ? planoModel.triagemNeonatalCid.id : null,
                        ciapId: planoModel.triagemNeonatalCiap ? planoModel.triagemNeonatalCiap.id : null,
                        justificativa: planoModel.triagemNeonatalJustificativa ?? null,
                        observacao: planoModel.triagemNeonatalObservacao ?? null,
                    },
                    solicitacoesExamesComuns: planoModel.solicitacoesExamesComuns.map(solicitacaoExameComum => {
                        return {
                            exames: solicitacaoExameComum.exames.map(exame => {
                                return {exameId: exame.id}
                            }),
                            cidId: solicitacaoExameComum.cid ? solicitacaoExameComum.cid.id : null,
                            ciapId: solicitacaoExameComum.ciap ? solicitacaoExameComum.ciap.id : null,
                            classificacaoRiscoId: solicitacaoExameComum.classificacaoRiscoId,
                            justificativa: solicitacaoExameComum.justificativa,
                            observacao: solicitacaoExameComum.observacao,
                        }
                    }),
                    testesRapidos: planoModel.testesRapidos,
                    solicitacoesExamesAltoCusto: planoModel.solicitacoesExamesAltoCusto.map(solicitacaoExameAltoCusto => {
                        return {
                            exames: solicitacaoExameAltoCusto.exames.map(exame => {
                                return {exameId: exame.id}
                            }),
                            cidId: solicitacaoExameAltoCusto.cid ? solicitacaoExameAltoCusto.cid.id : null,
                            ciapId: solicitacaoExameAltoCusto.ciap ? solicitacaoExameAltoCusto.ciap.id : null,
                            classificacaoRiscoId: solicitacaoExameAltoCusto.classificacaoRiscoId,
                            justificativa: solicitacaoExameAltoCusto.justificativa,
                            observacao: solicitacaoExameAltoCusto.observacao,
                        }
                    }),
                    solicitacoesProcedimentosCirurgicos: planoModel.solicitacoesProcedimentosCirurgicos.map(solicitacaoProcedimentoCirurgico => {
                        return {
                            procedimentosCirurgicos: solicitacaoProcedimentoCirurgico.procedimentosCirurgicos.map(procedimentoCirurgico => {
                                return {procedimentoCirurgicoId: procedimentoCirurgico.id}
                            }),
                            cidId: solicitacaoProcedimentoCirurgico.cid ? solicitacaoProcedimentoCirurgico.cid.id : null,
                            ciapId: solicitacaoProcedimentoCirurgico.ciap ? solicitacaoProcedimentoCirurgico.ciap.id : null,
                            classificacaoRiscoId: solicitacaoProcedimentoCirurgico.classificacaoRiscoId,
                            justificativa: solicitacaoProcedimentoCirurgico.justificativa,
                            observacao: solicitacaoProcedimentoCirurgico.observacao,
                        }
                    }),
                    atestados: planoModel.atestados.map(atestado => {
                        return {
                            modeloId: atestado.modeloId,
                            descricao: atestado.descricao,
                            nomeAcompanhante: atestado.isAtestadoAcompanhante ? atestado.nome : null,
                            documentoTipoId: atestado.documentoTipoId,
                            cpf: atestado.cpf ? this.unMaskCpf(atestado.cpf) : null,
                            cns: atestado.cns ? this.unMaskCns(atestado.cns) : null,
                            data: atestado.data,
                            horario: atestado.horario,
                            horarioInicial: atestado.horarioInicial,
                            dias: atestado.dias,
                            quantidadeHoras: atestado.quantidadeHoras,
                            cidId: atestado.cid ? atestado.cid.id : null,
                        }
                    }),
                    declaracoesComparecimento: planoModel.declaracoesComparecimento.map(declaracaoComparecimento => {
                        return {
                            turnoId: declaracaoComparecimento.turno ? declaracaoComparecimento.turno.id : null,
                            entrada: declaracaoComparecimento.entrada,
                            saida: declaracaoComparecimento.saida,
                            nomeAcompanhante: declaracaoComparecimento.nomeAcompanhante,
                            motivoComparecimento: declaracaoComparecimento.motivoComparecimento,
                        }
                    }),
                    cartasMedicas: planoModel.cartasMedicas,
                    orientacoes: planoModel.orientacoes,
                    encaminhamentos: planoModel.encaminhamentos.map(encaminhamento => {
                        return {
                            tipoId: encaminhamento.tipo.id,
                            intersetorialInfraestruturaId: encaminhamento.infraestrutura ? encaminhamento.infraestrutura.id : null,
                            servicoEspecializadoEspecialidadeId: encaminhamento.especialidade ? encaminhamento.especialidade.id : null,
                            servicoEspecializadoComplemento: encaminhamento.complemento,
                            servicoEspecializadoCidId: encaminhamento.cid ? encaminhamento.cid.id : null,
                            servicoEspecializadoCiapId: encaminhamento.ciap ? encaminhamento.ciap.id : null,
                            servicoEspecializadoClassificacaoRiscoId: encaminhamento.classificacaoRisco ? encaminhamento.classificacaoRisco.id : null,
                            servicoEspecializadoMotivo: encaminhamento.motivo,
                            servicoEspecializadoObservacao: encaminhamento.observacao,
                            internacaoHospitalarUnidadeSolicitanteId: encaminhamento.internacaoHospitalar?.unidadeSolicitanteId,
                            internacaoHospitalarCidPrincipalId: encaminhamento.internacaoHospitalar?.cidPrincipal?.id ?? null,
                            ...(encaminhamento.internacaoHospitalar?.cidSecundario?.id && {
                                internacaoHospitalarCidSecundarioId:
                                    encaminhamento.internacaoHospitalar.cidSecundario.id
                            }),
                            ...(encaminhamento.internacaoHospitalar?.cidCausasAssociadas?.id && {
                                internacaoHospitalarCidCausasAssociadasId:
                                    encaminhamento.internacaoHospitalar.cidCausasAssociadas.id
                            }),
                            internacaoHospCondicoesQueJustificamInternacao: encaminhamento.internacaoHospitalar?.condicoesQueJustificamInternacao,
                            internacaoHospPrincipaisResultadosDeProvasDiagnosticas: encaminhamento.internacaoHospitalar?.principaisResultadosDeProvasDiagnosticas,
                            internacaoHospPrincipaisSinaisSintomasClinicos: encaminhamento.internacaoHospitalar?.principaisSinaisSintomasClinicos,
                            internacaoHospitalarProcedimentoSolicitadoId: encaminhamento.internacaoHospitalar?.procedimento?.procedimentoSolicitado?.id ?? null,
                            internacaoHospitalarDataSolicitacao: encaminhamento.internacaoHospitalar?.procedimento?.dataSolicitacao,
                            internacaoHospitalarClinicaId: encaminhamento.internacaoHospitalar?.procedimento?.clinicaId,
                            internacaoHospitalarCaraterInternacaoId: encaminhamento.internacaoHospitalar?.procedimento?.caraterInternacaoId,
                            internacaoHospitalarProfissionalSolicitanteAssistenteId: encaminhamento.internacaoHospitalar?.procedimento?.profissionalSolicitanteAssistente?.id ?? null,
                            internacaoHospitalarProfissionalSolicitanteDocumentoTipoId: encaminhamento.internacaoHospitalar?.procedimento?.profissionalSolicitanteDocumentoTipoId,
                            internacaoHospitalarProfissionalSolicitanteDocumentoNumero: encaminhamento.internacaoHospitalar?.procedimento?.profissionalSolicitanteDocumentoNumero,
                            ...(encaminhamento.internacaoHospitalar?.causasExternas?.causaExternaId && {
                                internacaoHospitalarCausaExternaId:
                                    encaminhamento.internacaoHospitalar.causasExternas.causaExternaId
                            }),
                            ...(encaminhamento.internacaoHospitalar?.causasExternas?.cnpjSeguradora && {
                                internacaoHospitalarCnpjSeguradora:
                                    encaminhamento.internacaoHospitalar.causasExternas.cnpjSeguradora
                            }),
                            ...(encaminhamento.internacaoHospitalar?.causasExternas?.numeroBilhete && {
                                internacaoHospitalarNumeroBilhete:
                                    encaminhamento.internacaoHospitalar.causasExternas.numeroBilhete
                            }),
                            ...(encaminhamento.internacaoHospitalar?.causasExternas?.serie && {
                                internacaoHospitalarSerie:
                                    encaminhamento.internacaoHospitalar.causasExternas.serie
                            }),
                            ...(encaminhamento.internacaoHospitalar?.causasExternas?.cnpjEmpresa && {
                                internacaoHospitalarCnpjEmpresa:
                                    encaminhamento.internacaoHospitalar.causasExternas.cnpjEmpresa
                            }),
                            ...(encaminhamento.internacaoHospitalar?.causasExternas?.cnaeEmpresa && {
                                internacaoHospitalarCnaeEmpresa:
                                    encaminhamento.internacaoHospitalar.causasExternas.cnaeEmpresa
                            }),
                            ...(encaminhamento.internacaoHospitalar?.causasExternas?.cbor && {
                                internacaoHospitalarCbor:
                                    encaminhamento.internacaoHospitalar.causasExternas.cbor
                            }),
                            ...(encaminhamento.internacaoHospitalar?.causasExternas?.vinculoPrevidenciaId && {
                                internacaoHospitalarVinculoPrevidenciaId:
                                    encaminhamento.internacaoHospitalar.causasExternas.vinculoPrevidenciaId
                            }),
                            ...(encaminhamento.internacaoHospitalar?.autorizacao?.profissionalAutorizador?.id && {
                                internacaoHospitalarProfissionalAutorizadorId:
                                    encaminhamento.internacaoHospitalar.autorizacao.profissionalAutorizador.id
                            }),
                            ...(encaminhamento.internacaoHospitalar?.autorizacao?.dataAutorizacao && {
                                internacaoHospitalarDataAutorizacao:
                                    encaminhamento.internacaoHospitalar.autorizacao.dataAutorizacao
                            }),
                            ...(encaminhamento.internacaoHospitalar?.autorizacao?.codigoOrgaoEmissor && {
                                internacaoHospitalarCodigoOrgaoEmissor:
                                    encaminhamento.internacaoHospitalar.autorizacao.codigoOrgaoEmissor
                            }),
                            internacaoHospitalarProfissionalAutorizadorDocumentoTipoId: encaminhamento.internacaoHospitalar?.autorizacao?.profissionalAutorizadorDocumentoTipoId,
                            internacaoHospitalarProfissionalAutorizadorDocumentoNumero: encaminhamento.internacaoHospitalar?.autorizacao?.profissionalAutorizadorDocumentoNumero,
                        }
                    }),
                    compartilhamentosCuidado: planoModel.compartilhamentosCuidado.map(compartilhamentoCuidado => {
                        return {
                            especialidadeId: compartilhamentoCuidado.especialidadeId,
                            usuarioId: compartilhamentoCuidado.usuario.id,
                            ciapId: compartilhamentoCuidado.ciap ? compartilhamentoCuidado.ciap.id : null,
                            cidId: compartilhamentoCuidado.cid ? compartilhamentoCuidado.cid.id : null,
                            classificacaoRiscoId: compartilhamentoCuidado.classificacaoRisco.id,
                            discussaoCasoClinico: compartilhamentoCuidado.discussaoCasoClinico,
                        }
                    }),
                },
                finalizacao: {
                    atendimentoTipoId: finalizacaoModel.atendimentoTipoId,
                    atendimentoCompartilhadoUsuarioId: finalizacaoModel.atendimentoCompartilhadoUsuario ? finalizacaoModel.atendimentoCompartilhadoUsuario.id : null,
                    procedimentosAdministrativos: finalizacaoModel.procedimentosAdministrativos.map(procedimentoAdministrativo => {
                        return {
                            procedimentoId: procedimentoAdministrativo.procedimento.id,
                            cidId: procedimentoAdministrativo.cid ? procedimentoAdministrativo.cid.id : null,
                            automatico: procedimentoAdministrativo.automatico,
                            quantidade: procedimentoAdministrativo.quantidade,
                        }
                    }),
                    casosSuspeitos: finalizacaoModel.casosSuspeitos.map(casoSuspeito => casoSuspeito.id),
                    racionalidadeSaudeId: finalizacaoModel.racionalidadeSaudeId,
                    condutas: finalizacaoModel.condutas,
                    equipeId: finalizacaoModel.equipeId,
                    turnoId: finalizacaoModel.turnoId,
                    atencaoBasicaLocalAtendimentoId: finalizacaoModel.atencaoBasicaLocalAtendimentoId,
                    saudeBucal: {
                        consultaTipoId: finalizacaoModel.saudeBucal.consultaTipoId,
                        fornecimentos: finalizacaoModel.saudeBucal.fornecimentos,
                    },
                    desfecho: {
                        ocupacaoId: finalizacaoModel.desfecho.ocupacaoId,
                        especialidadeId: finalizacaoModel.desfecho.especialidadeId,
                        usuarioId: finalizacaoModel.desfecho.usuarioId,
                        prioridadeId: finalizacaoModel.desfecho.prioridadeId,
                        servicos: finalizacaoModel.desfecho.servicos,
                        finalizado: finalizado,
                        centroCustoEncaminhamentoId: finalizacaoModel.desfecho.centroCustoEncaminhamentoId,
                        posConsulta: finalizacaoModel.desfecho.posConsulta,
                        protocoloFechamento: finalizacaoModel.desfecho.protocoloFechamento,
                    },
                    isTratamentoConcluido: finalizacaoModel.isTratamentoConcluido,
                    emadTipoAtendimentoId: finalizacaoModel.emadTipoAtendimentoId,
                    emadModalidadeId: finalizacaoModel.emadModalidadeId,
                    emadCondutaDesfechoId: finalizacaoModel.emadCondutaDesfechoId,
                    emadProcedenciaId: finalizacaoModel.emadProcedenciaId,
                    emadCidPrimarioId: finalizacaoModel.emadCidPrimarioId
                        ? finalizacaoModel.emadCidPrimarioId.id
                        : finalizacaoModel.emadSelectCidPrimarioId,
                    emadConclusaoId: finalizacaoModel.emadConclusaoId,
                    emadConclusaoJustificativa: finalizacaoModel.emadConclusaoJustificativa,
                    emadCuidadorId: finalizacaoModel.emadCuidadorId,
                    emadCnsCuidador: finalizacaoModel.emadCnsCuidador ?? null,
                    emadCpfCuidador: finalizacaoModel.emadCpfCuidador ?? null,
                    fichaAvaliacao: this.fichaAvaliacao,
                    ociDesfechoEtapaClinicaId: finalizacaoModel.ociDesfechoEtapaClinicaId,
                    apacMotivoSaidaPermanenciaId: finalizacaoModel.apacMotivoSaidaPermanenciaId,
                },
                medicoes: {
                    antropometrias: this.medicaoData.model.antropometrias.map(antropometria => {
                        return {
                            medidoEm: antropometria.medidoEm,
                            peso: antropometria.peso,
                            altura: antropometria.altura,
                            perimetroCefalico: antropometria.perimetroCefalico,
                            circunferenciaAbdominal: antropometria.circunferenciaAbdominal,
                            perimetroPanturrilha: antropometria.perimetroPanturrilha,
                        }
                    }),
                },
                medicamentosEmUso: this.medicamentoUsoData.model.medicamentosEmUso,
                feridas: this.feridaData.model.feridas.map(ferida => {
                    return {
                        ...ferida,
                        procedimentos: ferida.procedimentos
                    };
                }),
                raas: {
                    origemPacienteId: this.hasProcedimentoRaas ? this.model.soap.raas.origemPacienteId : null,
                    destinoPacienteId: this.hasProcedimentoRaas ? this.model.soap.raas.destinoPacienteId : null,
                    motivoSaidaPermanenciaId: this.hasProcedimentoRaas ? this.model.soap.raas.motivoSaidaPermanenciaId : null,
                    caraterAtendimentoId: this.hasProcedimentoRaas ? this.model.soap.raas.caraterAtendimentoId : null,
                    numeroAutorizacao: this.hasProcedimentoRaas && this.hasProcedimentoRaasQuePrecisaDeAutorizacao
                        ? this.model.soap.raas.numeroAutorizacao : null,
                    classificacaoId: this.hasProcedimentoRaas && this.hasProcedimentoRaasQuePrecisaDeClassificacao
                        ? this.model.soap.raas.classificacaoId : null,
                    localRealizacaoExameId: this.hasProcedimentoRaas ? this.model.soap.raas.localRealizacaoExameId : null,
                },
                perfisEpidemiologicos: this.model.soap.perfisEpidemiologicos,
                observacaoPerfilEpidemiologico: this.model.soap.observacaoPerfilEpidemiologico,
                ivcf: {
                    desejaPreencher: this.model.soap.ivcf.desejaPreencher,
                    estadoSaudeGeral: this.model.soap.ivcf.estadoSaudeGeral,
                    limitacaoCompras: this.model.soap.ivcf.limitacaoCompras,
                    limitacaoGestaoFinanceira: this.model.soap.ivcf.limitacaoGestaoFinanceira,
                    limitacaoTarefasDomesticas: this.model.soap.ivcf.limitacaoTarefasDomesticas,
                    banhoIndependencia: this.model.soap.ivcf.banhoIndependencia,
                    relatoEsquecimentoPorTerceiros: this.model.soap.ivcf.relatoEsquecimentoPorTerceiros,
                    esquecimentoPiorando: this.model.soap.ivcf.esquecimentoPiorando,
                    esquecimentoImpactaAtividades: this.model.soap.ivcf.esquecimentoImpactaAtividades,
                    humorTristezaDesanimo: this.model.soap.ivcf.humorTristezaDesanimo,
                    perdaInteresseAtividades: this.model.soap.ivcf.perdaInteresseAtividades,
                    limitacaoElevarBracos: this.model.soap.ivcf.limitacaoElevarBracos,
                    limitacaoMotricidadeFina: this.model.soap.ivcf.limitacaoMotricidadeFina,
                    perdaPesoNaoIntencional: this.model.soap.ivcf.perdaPesoNaoIntencional,
                    imcAbaixo_22: this.model.soap.ivcf.imcAbaixo22,
                    panturrilhaAbaixo_31: this.model.soap.ivcf.panturrilhaAbaixo31,
                    marchaLenta_4mMaior_5s: this.model.soap.ivcf.marchaLenta4mMaior5s,
                    dificuldadeCaminharImpactoAtividades: this.model.soap.ivcf.dificuldadeCaminharImpactoAtividades,
                    quedasRecorrentes: this.model.soap.ivcf.quedasRecorrentes,
                    incontinencia: this.model.soap.ivcf.incontinencia,
                    problemaVisaoImpactoAtividades: this.model.soap.ivcf.problemaVisaoImpactoAtividades,
                    problemaAudicaoImpactoAtividades: this.model.soap.ivcf.problemaAudicaoImpactoAtividades,
                    doencasCronicasMultiplas: this.model.soap.ivcf.doencasCronicasMultiplas,
                    polifarmacia_5OuMaisMedicamentos: this.model.soap.ivcf.polifarmacia5OuMaisMedicamentos,
                    internacaoUltimos_6Meses: this.model.soap.ivcf.internacaoUltimos6Meses,
                },
                riscoCardiovascularFramingham: {
                    colesterolTotal: this.model.soap.riscoCardiovascularFramingham.colesterolTotal,
                    colesterolHdl: this.model.soap.riscoCardiovascularFramingham.colesterolHdl,
                    tomaRemedioHipertensao: this.model.soap.riscoCardiovascularFramingham.tomaRemedioHipertensao,
                    tabagista: this.model.soap.riscoCardiovascularFramingham.tabagista,
                    diabetico: this.model.soap.riscoCardiovascularFramingham.diabetico,
                    pontuacao: this.model.soap.riscoCardiovascularFramingham.pontuacao
                },
            }

            const semAssinatura =
                this.additionals.permissaoAssinatura.length === 0 ||
                (
                    finalizado == false && finalizacaoModel.desfecho.centroCustoEncaminhamentoId == null &&
                    (
                        (this.lotacao.usuarioId == finalizacaoModel.desfecho.usuarioId &&
                        this.lotacao.ocupacaoId == finalizacaoModel.desfecho.ocupacaoId) ||
                        finalizacaoModel.desfecho.usuarioId == null
                    )
                );

            this.repositories.atendimento.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {

                    this.saveImagesFeridas();

                    if (rascunho === true) {
                        this.additionals.isRascunho = true

                        this.showSaveNotification()
                    } else if (semAssinatura)
                    {
                        this.openModalImpressao(response.data.atendimentoId)
                    } else {

                        const finish = () => {

                            this.openModalImpressao(response.data.atendimentoId)
                        }

                        this.afterSign = (atendimentoAssinado) => {

                            return this.repositories.atendimento.storeAtendimentoAssinado(response.data.id, {
                                atendimento_assinado: atendimentoAssinado
                            })
                        }

                        this.onSign = () => finish()
                        this.onSkipSign = () => finish()

                        this.askToSignAtendimento(
                            async () => this.openModalSignImpressao(response.data.atendimentoId, response.data.id),
                            async () => finish()
                        )
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        async saveImagesFeridas() {

            const feridasComImagem = this.feridaData.model.feridas.filter(
                f => f.image && f.image.length > 0
            )

            if (feridasComImagem.length === 0) return

            const formData = new FormData()

            feridasComImagem.forEach(ferida => {
                ferida.image.forEach(img => {

                    formData.append('images[]', img)
                    formData.append('ids[]', ferida.idOld ?? ferida.id)
                })
            })

            try {

                await this.repositories.atendimento.uploadImagem(formData)

            } catch (error) {

                this.handleError(error)
            }
        },
        save(rascunho = false) {
            if (rascunho === true) {
                this.store(true)
            } else {
                this.$refs.RkmForm.validate()
                    .then(valid => {
                        if (valid === false) return

                        if (!this.hasProcedimentoLancado) {
                            this.showValidationNotification('É necessário incluir ao menos um procedimento no atendimento.')
                            return
                        }

                        if (this.form.soap.finalizacao.equipes.length > 0) {

                            if (this.model.soap.avaliacao.condicoesAvaliadas.length === 0
                                && this.model.soap.avaliacao.doencasTransmissiveis.length === 0
                                && this.model.soap.avaliacao.rastreamentos.length === 0
                                && this.model.soap.avaliacao.problemasCondicoes.length === 0
                            ) {
                                this.showValidationNotification('É necessário incluir ao menos um problema/condição na avaliação.')
                                return
                            }
                        }

                        const exibeMsgPrescricao = this.model.soap.plano.prescricaoMedicamentos.find(medicamento => medicamento.material
                            && medicamento.material.id && medicamento.unidadeMedidaId === null)

                        if (exibeMsgPrescricao) {

                            this.showValidationNotification(`Existe prescrição de medicamento sem unidade de medida
                                informada. Para registrá-la, é necessário fornecer essa informação.`)
                            return
                        }

                        if ((this.model.soap.finalizacao.saudeBucal.consultaTipoId === 1
                            || this.model.soap.finalizacao.saudeBucal.consultaTipoId === 2)
                            && Object.values(this.model.soap.finalizacao.condutas).includes(5)
                        ) {

                            this.showValidationNotification('De acordo com regras do ESUS, conduta Alta do Episódio não pode ser selecionada se Primeira consulta odontológica programática ou Consulta de retorno em odontologia foi selecionado no Tipo de consulta.')
                            return
                        }

                        if (this.model.soap.oci.oci
                            && !this.additionals.oci.ultimaEtapaRealizadaMesmoAtendimento
                            && !this.additionals.oci.recusouContinuidadeOci
                        ) {

                            if (!this.model.soap.avaliacao.problemasCondicoes.find(pc => pc.cid && this.model.soap.oci.oci.cids.includes(pc.cid.id))) {

                                this.showValidationNotification('É obrigatório informar um CID compatível com o protocolo em andamento.')

                                return
                            }

                            if (this.model.soap.oci.oci.etapaClinicaAtualId === this.enums.etapaClinica.ENTRADA) {

                                if (!this.hasProcedimentosPrimariosOciIncluso()) {

                                    this.$refs.ModalProcedimentoPrimarioOci.open(this.model.soap.oci.oci.procedimentosPrimarios)

                                    return
                                }
                            }
                            else if (this.model.soap.oci.oci.etapaClinicaAtualId === this.enums.etapaClinica.ENTRADA_ALTA) {

                                if (!this.hasProcedimentosPrimariosOciInclusoEtapaEntradaAlta()) {

                                    this.$refs.ModalProcedimentoPrimarioOci.open(this.model.soap.oci.oci.procedimentosPrimarios, false)

                                    return
                                }
                            }

                            if (this.model.soap.oci.oci.procedimentosConsulta.length > 0
                                && !this.model.soap.finalizacao.procedimentosAdministrativos
                                    .some(pa => this.model.soap.oci.oci.procedimentosConsulta.includes(pa.procedimento.codigo))
                            ) {

                                this.showValidationNotification('Para esta OCI é obrigatório registrar uma consulta compatível. Insira um procedimento de consulta compatível com OCI.')

                                return
                            }
                        }

                        const hasExameImagemExigePesoAlturaCircunferencia = this.model.soap.plano.solicitacoesExamesAltoCusto
                            .some(solicitacao => solicitacao.exames.some(exame => exame.exigirPesoAlturaCircunferencia))

                        const hasProcedimentosCirurgicosExigePesoAlturaCircunferencia = this.model.soap.plano.solicitacoesProcedimentosCirurgicos
                            .some(solicitacao => solicitacao.procedimentosCirurgicos.some(procedimento => procedimento.exigirPesoAlturaCircunferencia))

                        const hasEncaminhamentosExigePesoAlturaCircunferencia = this.model.soap.plano.encaminhamentos
                            .some(solicitacao => solicitacao.especialidade && solicitacao.especialidade.exigirPesoAlturaCircunferencia)

                        if (hasExameImagemExigePesoAlturaCircunferencia || hasProcedimentosCirurgicosExigePesoAlturaCircunferencia || hasEncaminhamentosExigePesoAlturaCircunferencia) {

                            if (!this.model.soap.objetivo.antropometria.peso || !this.model.soap.objetivo.antropometria.altura
                                || !this.model.soap.objetivo.antropometria.circunferenciaAbdominal) {

                                this.showValidationNotification('É necessário informar o peso, altura e circunferência abdominal.')
                                return
                            }
                        }

                        const continueStore = async () => {

                            this.validaProcedimentoFerida()
                                .then(cboValido => {
                                    if (!cboValido) return

                                    if (!!this.additionals.faturaProcedimentoRaas && this.hasProcedimentoRaas) {
                                        this.checkCamposInvalidosParaFaturarProcedimentoRaas()
                                    } else {
                                        this.store()
                                    }
                                })
                        }

                        if (this.model.soap.oci.oci
                            && !this.additionals.oci.ultimaEtapaRealizadaMesmoAtendimento
                            && !this.additionals.oci.recusouContinuidadeOci
                            && this.model.soap.oci.oci.etapaClinicaAtualId === this.enums.etapaClinica.ENTRADA_ALTA
                        ) {

                            this.showConfirmation(
                                'Ao salvar, o protocolo será encerrado porque a etapa obrigatória é concluída no mesmo atendimento. Deseja continuar?',
                                continueStore
                            )
                        }
                        else {

                            continueStore()
                        }
                    })
            }
        },
        validaProcedimentoFerida() {

            const procedimentos = this.model.soap.plano.procedimentosFeridas || []
            const ids = procedimentos
                .filter(p => p.procedimento && p.procedimento.id)
                .map(p => p.procedimento.id)

            if (ids.length === 0) {
                return Promise.resolve(true)
            }

            this.setLoading()

            return this.repositories.atendimento.validarProcedimentosCbo({ procedimento_ids: ids })
                .then(validResponse => {
                    const idsValidos = validResponse.data
                    const procedimentosExcluidos = procedimentos.filter(p => p.procedimento && !idsValidos.includes(p.procedimento.id))

                    if (procedimentosExcluidos.length > 0) {
                        const nomes = procedimentosExcluidos.map(p => `<b>${p.procedimento.codigo} - ${p.procedimento.nome}</b>`).join('<br>')
                        this.showValidationNotification(`Os seguintes procedimentos de ferida não são compatíveis com o CBO do profissional:<br>${nomes}`)
                        return false
                    }

                    return true
                })
                .catch(error => {
                    this.handleError(error)
                    return false
                })
                .finally(() => this.unsetLoading())
        },
        hasProcedimentosPrimariosOciInclusoEtapaEntradaAlta() {

            return this.model.soap.oci.oci.procedimentosPrimarios.every(p =>
                !!this.model.soap.oci.oci.procedimentosRealizadosPreviamente.find(pr => pr.codigo === p.codigo)
            )
        },
        hasProcedimentosPrimariosOciIncluso() {

            return this.model.soap.oci.oci.procedimentosPrimarios.every(p =>
                !!this.model.soap.oci.oci.procedimentosRealizadosPreviamente.find(pr => pr.codigo === p.codigo)
                || !!this.model.soap.plano.solicitacoesExamesComuns.find(s => !!s.exames.find(e => e.codigo === p.codigo))
                || !!this.model.soap.plano.solicitacoesExamesAltoCusto.find(s => !!s.exames.find(e => e.codigo === p.codigo))
            )
        },
        openModalImpressao(atendimentoId) {
            this.$refs.ModalImpressao.open('atendimento', atendimentoId)
        },
        openModalSignImpressao(atendimentoId, id) {
            this.$refs.ModalSignImpressao.open('atendimento', atendimentoId, id)
        },
        closedModalImpressao() {
            const {
                hasPermissaoEquipeAtendimentoDomiciliar,
                hasPermissaoEquipeAvaliacao,
                criaFichaAtencaoBasicaAtendimentoDomiciliar,
                criaFichaAtencaoBasicaAvaliacao,
                hasAvaliacaoElegibilidade
            } = this.additionals;

            let mensagem = null;

            if (criaFichaAtencaoBasicaAtendimentoDomiciliar && !hasPermissaoEquipeAtendimentoDomiciliar &&
                criaFichaAtencaoBasicaAvaliacao && !hasAvaliacaoElegibilidade && !hasPermissaoEquipeAvaliacao
                && this.fichaAvaliacao) {

                    mensagem = `Seu atendimento foi finalizado, mas a ficha de Avaliação de Elegibilidade e Admissão
                    e a ficha de Atendimento Domiciliar referente ao seu atendimento não serão geradas.
                    Por favor, comunique o seu responsável.`;

            } else if (criaFichaAtencaoBasicaAtendimentoDomiciliar && !hasPermissaoEquipeAtendimentoDomiciliar) {

                mensagem = `Seu atendimento foi finalizado, mas a ficha de Atendimento Domiciliar referente ao seu atendimento
                não será gerada. Por favor, comunique o seu responsável.`;

            } else if (criaFichaAtencaoBasicaAvaliacao && this.fichaAvaliacao && !hasAvaliacaoElegibilidade && !hasPermissaoEquipeAvaliacao) {

                mensagem = `Seu atendimento foi finalizado, mas a Avaliação de Elegibilidade e Admissão referente ao seu atendimento
                não será gerada. Por favor, comunique o seu responsável.`;
            }

            if (mensagem) {

                this.showAlert(mensagem, "Atenção");
            } else {

                this.showSaveNotification();
            }

            this.$emit('saved');
        },
        getProblemasCondicoesGravidez() {
            const problemasCondicoesGravidez = []

            if (this.hasGravidezNormal) {
                problemasCondicoesGravidez.push(this.getProblemaCondicaoGravidezNormal())
            }

            if (this.hasGravidezAltoRisco) {
                this.getProblemasCondicoesGravidezAltoRisco().forEach(problemaCondicaoGravidezNormal => problemasCondicoesGravidez.push(problemaCondicaoGravidezNormal))
            }

            return problemasCondicoesGravidez
        },
        getProblemaCondicaoGravidezNormal() {
            return this.model.soap.avaliacao.problemasCondicoes.find(this.isGravidezNormal)
        },
        getProblemasCondicoesGravidezAltoRisco() {
            return this.model.soap.avaliacao.problemasCondicoes.filter(this.isGravidezAltoRisco)
        },
        getProblemasCondicoesDesfechoGravidez() {
            return this.model.soap.avaliacao.problemasCondicoes.filter(this.isDesfechoGravidez)
        },
        getProblemaCondicaoPacienteGravidezNormal() {
            return this.form.soap.avaliacao.problemaCondicao.problemasCondicoesPaciente.find(problemaCondicaoPaciente => {
                let isCiapGravidezNormal = false
                let isCidGravidezNormal = false

                if (problemaCondicaoPaciente.ciap) {
                    isCiapGravidezNormal = this.ciapsGravidez.normal.includes(problemaCondicaoPaciente.ciap.codigo)
                }

                if (problemaCondicaoPaciente.cid) {
                    isCidGravidezNormal = this.cidsGravidez.normal.includes(problemaCondicaoPaciente.cid.codigo)
                }

                return isCiapGravidezNormal || isCidGravidezNormal
            })
        },
        getProblemaCondicaoPacienteDesfechoGravidez() {
            return this.form.soap.avaliacao.problemaCondicao.problemasCondicoesPaciente.filter(this.isDesfechoGravidez)
        },
        printCarteiraVacinacao() {
            this.setLoading()

            this.repositories.impressaoImunizacao.carteiraVacinacao(this.form.paciente.id)
                .then(response => {

                    this.openFile(response.data, response.headers['content-type'])
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        checkCamposInvalidosParaFaturarProcedimentoRaas() {
            const camposInvalidos = []

            if (!this.form.unidade.cnes) {
                camposInvalidos.push('CNES da unidade de atendimento')
            }

            if (!this.form.paciente.nomeMae) {
                camposInvalidos.push('Nome da mãe do paciente')
            }

            if (!this.form.paciente.cep) {
                camposInvalidos.push('CEP do logradouro do paciente')
            }

            if (!this.form.paciente.ibge) {
                camposInvalidos.push('IBGE do logradouro do paciente')
            }

            if (!this.form.paciente.dataNascimento) {
                camposInvalidos.push('Data de nascimento do paciente')
            }

            if (!this.form.paciente.sexoId) {
                camposInvalidos.push('Sexo do paciente')
            }

            if (!this.form.paciente.racaCorId) {
                camposInvalidos.push('Raça/Cor do paciente')
            }

            if (!this.form.paciente.telefoneNumero) {
                camposInvalidos.push('Número do telefone do paciente')
            }

            if (!this.model.soap.avaliacao.problemasCondicoes.some(problemaCondicao => !!problemaCondicao.cid)) {
                camposInvalidos.push('CID principal é obrigatório')
            }

            if (!this.model.soap.raas.origemPacienteId) {
                camposInvalidos.push('Origem do paciente')
            }

            if (!this.model.soap.raas.destinoPacienteId) {
                camposInvalidos.push('Destino do paciente')
            }

            if (!this.model.soap.raas.motivoSaidaPermanenciaId) {
                camposInvalidos.push('Motivo de saída/permanência')
            }

            if (!this.model.soap.raas.caraterAtendimentoId) {
                camposInvalidos.push('Caráter do atendimento')
            }

            if (this.hasProcedimentoRaasQuePrecisaDeAutorizacao && !this.model.soap.raas.numeroAutorizacao) {
                camposInvalidos.push('Número da autorização')
            }

            if (this.hasProcedimentoRaasQuePrecisaDeClassificacao && !this.model.soap.raas.classificacaoId) {
                camposInvalidos.push('Classificação')
            }

            if (!this.model.soap.raas.localRealizacaoExameId) {
                camposInvalidos.push('Local de realização do exame')
            }

            if (camposInvalidos.length > 0) {
                let message = 'Campos inválidos para faturamento RAAS:<ul>'

                camposInvalidos.forEach(campoInvalido => {
                    message = message + `<li>${campoInvalido}</li>`
                })

                message = message + '</ul>Deseja continuar?'

                this.showWarningConfirmation('Atenção', message, async () => this.store())
            } else {
                this.store()
            }
        },
        continueModal(impressoes, atendimentoId, id) {

            this.sign(impressoes, atendimentoId, id)
        },
        closedModalSignImpressao(atendimentoId) {

            this.openModalImpressao(atendimentoId)
        }
    },
    mixins: [ambulatorioAtendimentoExame, ambulatorioAtendimentoPreNatal, ambulatorioAssinaturaEletronica, error, file, formats, object, repository, stringCase, unmask],
    mounted() {
        this.load()
    },
    props: {
        filaId: {type: Number, required: true},
        agendamentoId: {type: Number},
        fichaAvaliacao: {type: Boolean, default: true},
    },
}
</script>